

import * as OM from '@/Model';
import { Options, Vue } from 'vue-class-component';
import * as Enum from '@/enum';
import toastr from 'toastr';
import ProductCourse from './productCourse.vue';
import ProductAppuntamento from './productAppuntamento.vue';
import { BaseProductClient, ProductAppuntamentoClient, ProductCourseClient, ProductSpedibileClient } from '@/services/Services';

@Options({
    components: {
        ProductCourse,
        ProductAppuntamento
    }
})
export default class ProductDetail extends Vue {
 
    product: OM.BaseProduct = null;
    productTypes: string[] = Enum.ProductType.GetAll();

    created(){
        if(this.$route.params.identifier as string == '0'){
            this.product = new OM.BaseProduct();
        } else {
            BaseProductClient.getById(this.$route.params.identifier as string)
            .then(x => {
                this.product = x;
            })
        }
    }

    save(){
        let promise;
        if(this.product.productType == Enum.ProductType.Spedibile) {
            promise = ProductSpedibileClient.save(this.product as OM.ProductSpedibile)
        } else if(this.product.productType == Enum.ProductType.Corso) {
            promise = ProductCourseClient.save(this.product as OM.ProductCourse)
        } else if(this.product.productType == Enum.ProductType.Appuntamento) {
            promise = ProductAppuntamentoClient.save(this.product as OM.ProductAppuntamento)
        }
        promise.then(x => {
            this.product.identifier = x;
            if(this.$route.params.identifier as string == '0'){
                this.$router.replace('/shopConfig/product/' + x);
            }
            toastr.success("Salvato");
        })
    }

}

